module.exports = __webpack_public_path__ + "img/medium-ship-wreck-1.04091645.png";